// extracted by mini-css-extract-plugin
export default {"badge":"MinimalSoundIndicator_badge__nkcVm","tooltipInnerStyle":"MinimalSoundIndicator_tooltipInnerStyle__b9ZEY"};